<template>
  <Card class="my-3">
    <template #title>
      <div class="text-lg font-medium">Per Group Daily</div>
    </template>
    <template #content>
      <div class="relative">
        <line-chart
          class="pb-4"
          :data="chartData"
          :options="{
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function (tooltipItem) {
                  const value = tooltipItem.yLabel;
                  return `$${value
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
                },
              },
            },
          }"
          legend="bottom"
        ></line-chart>

        <LoaderSm v-if="chartLoader > 0" />
      </div>
      <DataTable
        :value="tableData"
        :defaultSortOrder="-1"
        class="p-datatable-striped p-datatable-sm"
        :paginator="true"
        :rows="10"
        :totalRecords="totalRecords"
        lazy
        @page="fetchData"
        @sort="fetchData"
        :loading="tableLoader > 0"
      >
        <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          sortable
        ></Column>
        <template #loadingicon>
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </template>
        <template #paginatorstart>
          <Button
            type="button"
            icon="pi pi-refresh"
            @click="fetchData({ page: 0, rows })"
            text
          />
        </template>
        <template #paginatorend>
          <download-csv :data="csvData" class="download-csv">
            <Button type="button" icon="pi pi-download" text />
          </download-csv>
        </template>
      </DataTable>
    </template>
  </Card>
</template>

<script setup>
import LoaderSm from "@/components/LoaderSm.vue";
import Button from "primevue/button";
import Card from "primevue/card";
import { onBeforeMount } from "vue";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const tableData = computed(
  () => store.state.AdminNewDashboardStore.dataTables.groupDaily.tableData
);
const csvData = computed(
  () => store.state.AdminNewDashboardStore.dataTables.groupDaily.csvData
);
const chartData = computed(
  () => store.state.AdminNewDashboardStore.dataTables.groupDaily.chartData
);
const totalRecords = computed(
  () => store.state.AdminNewDashboardStore.dataTables.groupDaily.totalRecords
);
const chartLoader = computed(
  () => store.state.AdminNewDashboardStore.loader.admin_per_group_daily_all
);
const tableLoader = computed(
  () => store.state.AdminNewDashboardStore.loader.admin_per_group_daily
);

const columns = [
  { header: "Date", field: "date_trunc" },
  { header: "Group", field: "group_name" },
  { header: "Player Loads", field: "loads" },
  { header: "Ad Impressions", field: "impressions" },
  { header: "Revenue", field: "revenue" },
  { header: "Cost", field: "cost" },
  { header: "Profit", field: "profit" },
  { header: "PM", field: "profit_margin" },
  { header: "RPM", field: "rpm" },
  { header: "CPM", field: "cpm" },
  { header: "RPL", field: "rpl" },
  { header: "CPL", field: "cpl" },
  { header: "Ad Play Rate", field: "fill_rate" },
];

const fetchData = ({
  page = 0,
  rows = 10,
  sortField,
  sortOrder,
  dataMode = "admin_per_group_daily",
}) => {
  store.dispatch("AdminNewDashboardStore/getTableData", {
    dataMode,
    page,
    rows,
    sortField,
    sortOrder,
  });
};

onBeforeMount(() => {
  fetchData({});
  fetchData({ dataMode: "admin_per_group_daily_all" });
});
</script>
